/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    Department,
    DepartmentFromJSON,
    DepartmentFromJSONTyped,
    DepartmentToJSON,
} from './Department';
import {
    DisciplineCategoryEnum,
    DisciplineCategoryEnumFromJSON,
    DisciplineCategoryEnumFromJSONTyped,
    DisciplineCategoryEnumToJSON,
} from './DisciplineCategoryEnum';
import {
    EvaluationTypeEnum,
    EvaluationTypeEnumFromJSON,
    EvaluationTypeEnumFromJSONTyped,
    EvaluationTypeEnumToJSON,
} from './EvaluationTypeEnum';
import {
    FisaLearningOutcomeDTO,
    FisaLearningOutcomeDTOFromJSON,
    FisaLearningOutcomeDTOFromJSONTyped,
    FisaLearningOutcomeDTOToJSON,
} from './FisaLearningOutcomeDTO';
import {
    GradingTypeEnum,
    GradingTypeEnumFromJSON,
    GradingTypeEnumFromJSONTyped,
    GradingTypeEnumToJSON,
} from './GradingTypeEnum';
import {
    IndicatorTypeEnum,
    IndicatorTypeEnumFromJSON,
    IndicatorTypeEnumFromJSONTyped,
    IndicatorTypeEnumToJSON,
} from './IndicatorTypeEnum';
import {
    Laboratory,
    LaboratoryFromJSON,
    LaboratoryFromJSONTyped,
    LaboratoryToJSON,
} from './Laboratory';
import {
    LearningCompetenceDTO,
    LearningCompetenceDTOFromJSON,
    LearningCompetenceDTOFromJSONTyped,
    LearningCompetenceDTOToJSON,
} from './LearningCompetenceDTO';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumFromJSONTyped,
    StudyPlanStatusEnumToJSON,
} from './StudyPlanStatusEnum';
import {
    StudyProgram,
    StudyProgramFromJSON,
    StudyProgramFromJSONTyped,
    StudyProgramToJSON,
} from './StudyProgram';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';
import {
    SubjectContent,
    SubjectContentFromJSON,
    SubjectContentFromJSONTyped,
    SubjectContentToJSON,
} from './SubjectContent';
import {
    SubjectEvaluation,
    SubjectEvaluationFromJSON,
    SubjectEvaluationFromJSONTyped,
    SubjectEvaluationToJSON,
} from './SubjectEvaluation';
import {
    SubjectStatusEnum,
    SubjectStatusEnumFromJSON,
    SubjectStatusEnumFromJSONTyped,
    SubjectStatusEnumToJSON,
} from './SubjectStatusEnum';

/**
 * 
 * @export
 * @interface SubjectFileDTO
 */
export interface SubjectFileDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    departmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    planDepartmentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    orderNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    nameRO?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    nameEN?: string | null;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof SubjectFileDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof SubjectFileDTO
     */
    studyYear?: StudyYearEnum;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    schoolYear?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    planYear?: number;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {EvaluationTypeEnum}
     * @memberof SubjectFileDTO
     */
    evaluationType?: EvaluationTypeEnum;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof SubjectFileDTO
     */
    subjectType?: IndicatorTypeEnum;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof SubjectFileDTO
     */
    subjectCategory?: IndicatorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    code?: string | null;
    /**
     * 
     * @type {GradingTypeEnum}
     * @memberof SubjectFileDTO
     */
    gradingType?: GradingTypeEnum;
    /**
     * 
     * @type {StudyPlanStatusEnum}
     * @memberof SubjectFileDTO
     */
    planStatus?: StudyPlanStatusEnum;
    /**
     * 
     * @type {SubjectStatusEnum}
     * @memberof SubjectFileDTO
     */
    status?: SubjectStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectFileDTO
     */
    isPartiallySaved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    totalWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    courseWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    labWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    seminarWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    projectWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    totalHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    courseHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    labHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    selfStudyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    tutoringHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    examHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    otherActivitiesHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    totalSelfStudyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    totalSemesterHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    credits?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    creditsIIS?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    creditsOE?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectFileDTO
     */
    labAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectFileDTO
     */
    seminarAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectFileDTO
     */
    projectAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectFileDTO
     */
    practiceAtPartner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    curriculumPrecondition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    respultsPrecondition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    courseConditions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    labConditions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    generalObjective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    specificCompetence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    generalCompetence?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    teachingKnowledges?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    teachingAptitudes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    teachingResponsabilities?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    teachingMethods?: string | null;
    /**
     * 
     * @type {Array<SubjectContent>}
     * @memberof SubjectFileDTO
     */
    subjectContents?: Array<SubjectContent> | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    courseBibliography?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    labBibliography?: string | null;
    /**
     * 
     * @type {Array<SubjectEvaluation>}
     * @memberof SubjectFileDTO
     */
    subjectEvaluations?: Array<SubjectEvaluation> | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    promotionConditions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectFileDTO
     */
    subjectCoroboration?: string | null;
    /**
     * 
     * @type {StudyProgram}
     * @memberof SubjectFileDTO
     */
    studyProgram?: StudyProgram;
    /**
     * 
     * @type {Array<AcademicUser>}
     * @memberof SubjectFileDTO
     */
    courseCoordinators?: Array<AcademicUser> | null;
    /**
     * 
     * @type {Array<AcademicUser>}
     * @memberof SubjectFileDTO
     */
    labCoordinators?: Array<AcademicUser> | null;
    /**
     * 
     * @type {Array<Laboratory>}
     * @memberof SubjectFileDTO
     */
    laboratories?: Array<Laboratory> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectFileDTO
     */
    learnings?: Array<string> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof SubjectFileDTO
     */
    learningResultsData?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<FisaLearningOutcomeDTO>}
     * @memberof SubjectFileDTO
     */
    fisaLearningOutcomes?: Array<FisaLearningOutcomeDTO> | null;
    /**
     * 
     * @type {Array<FisaLearningOutcomeDTO>}
     * @memberof SubjectFileDTO
     */
    minimumPromotionOutcomes?: Array<FisaLearningOutcomeDTO> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectFileDTO
     */
    eafsgAreas?: Array<string> | null;
    /**
     * 
     * @type {Department}
     * @memberof SubjectFileDTO
     */
    department?: Department;
    /**
     * 
     * @type {DisciplineCategoryEnum}
     * @memberof SubjectFileDTO
     */
    disciplineCategory?: DisciplineCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTO
     */
    practiceTotalHours?: number;
}

export function SubjectFileDTOFromJSON(json: any): SubjectFileDTO {
    return SubjectFileDTOFromJSONTyped(json, false);
}

export function SubjectFileDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectFileDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'planDepartmentId': !exists(json, 'planDepartmentId') ? undefined : json['planDepartmentId'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'nameRO': !exists(json, 'nameRO') ? undefined : json['nameRO'],
        'nameEN': !exists(json, 'nameEN') ? undefined : json['nameEN'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
        'schoolYear': !exists(json, 'schoolYear') ? undefined : json['schoolYear'],
        'planYear': !exists(json, 'planYear') ? undefined : json['planYear'],
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'evaluationType': !exists(json, 'evaluationType') ? undefined : EvaluationTypeEnumFromJSON(json['evaluationType']),
        'subjectType': !exists(json, 'subjectType') ? undefined : IndicatorTypeEnumFromJSON(json['subjectType']),
        'subjectCategory': !exists(json, 'subjectCategory') ? undefined : IndicatorTypeEnumFromJSON(json['subjectCategory']),
        'code': !exists(json, 'code') ? undefined : json['code'],
        'gradingType': !exists(json, 'gradingType') ? undefined : GradingTypeEnumFromJSON(json['gradingType']),
        'planStatus': !exists(json, 'planStatus') ? undefined : StudyPlanStatusEnumFromJSON(json['planStatus']),
        'status': !exists(json, 'status') ? undefined : SubjectStatusEnumFromJSON(json['status']),
        'isPartiallySaved': !exists(json, 'isPartiallySaved') ? undefined : json['isPartiallySaved'],
        'totalWeeklyHours': !exists(json, 'totalWeeklyHours') ? undefined : json['totalWeeklyHours'],
        'courseWeeklyHours': !exists(json, 'courseWeeklyHours') ? undefined : json['courseWeeklyHours'],
        'labWeeklyHours': !exists(json, 'labWeeklyHours') ? undefined : json['labWeeklyHours'],
        'seminarWeeklyHours': !exists(json, 'seminarWeeklyHours') ? undefined : json['seminarWeeklyHours'],
        'projectWeeklyHours': !exists(json, 'projectWeeklyHours') ? undefined : json['projectWeeklyHours'],
        'totalHours': !exists(json, 'totalHours') ? undefined : json['totalHours'],
        'courseHours': !exists(json, 'courseHours') ? undefined : json['courseHours'],
        'labHours': !exists(json, 'labHours') ? undefined : json['labHours'],
        'selfStudyHours': !exists(json, 'selfStudyHours') ? undefined : json['selfStudyHours'],
        'tutoringHours': !exists(json, 'tutoringHours') ? undefined : json['tutoringHours'],
        'examHours': !exists(json, 'examHours') ? undefined : json['examHours'],
        'otherActivitiesHours': !exists(json, 'otherActivitiesHours') ? undefined : json['otherActivitiesHours'],
        'totalSelfStudyHours': !exists(json, 'totalSelfStudyHours') ? undefined : json['totalSelfStudyHours'],
        'totalSemesterHours': !exists(json, 'totalSemesterHours') ? undefined : json['totalSemesterHours'],
        'credits': !exists(json, 'credits') ? undefined : json['credits'],
        'creditsIIS': !exists(json, 'creditsIIS') ? undefined : json['creditsIIS'],
        'creditsOE': !exists(json, 'creditsOE') ? undefined : json['creditsOE'],
        'labAtPartner': !exists(json, 'labAtPartner') ? undefined : json['labAtPartner'],
        'seminarAtPartner': !exists(json, 'seminarAtPartner') ? undefined : json['seminarAtPartner'],
        'projectAtPartner': !exists(json, 'projectAtPartner') ? undefined : json['projectAtPartner'],
        'practiceAtPartner': !exists(json, 'practiceAtPartner') ? undefined : json['practiceAtPartner'],
        'curriculumPrecondition': !exists(json, 'curriculumPrecondition') ? undefined : json['curriculumPrecondition'],
        'respultsPrecondition': !exists(json, 'respultsPrecondition') ? undefined : json['respultsPrecondition'],
        'courseConditions': !exists(json, 'courseConditions') ? undefined : json['courseConditions'],
        'labConditions': !exists(json, 'labConditions') ? undefined : json['labConditions'],
        'generalObjective': !exists(json, 'generalObjective') ? undefined : json['generalObjective'],
        'specificCompetence': !exists(json, 'specificCompetence') ? undefined : json['specificCompetence'],
        'generalCompetence': !exists(json, 'generalCompetence') ? undefined : json['generalCompetence'],
        'teachingKnowledges': !exists(json, 'teachingKnowledges') ? undefined : json['teachingKnowledges'],
        'teachingAptitudes': !exists(json, 'teachingAptitudes') ? undefined : json['teachingAptitudes'],
        'teachingResponsabilities': !exists(json, 'teachingResponsabilities') ? undefined : json['teachingResponsabilities'],
        'teachingMethods': !exists(json, 'teachingMethods') ? undefined : json['teachingMethods'],
        'subjectContents': !exists(json, 'subjectContents') ? undefined : (json['subjectContents'] === null ? null : (json['subjectContents'] as Array<any>).map(SubjectContentFromJSON)),
        'courseBibliography': !exists(json, 'courseBibliography') ? undefined : json['courseBibliography'],
        'labBibliography': !exists(json, 'labBibliography') ? undefined : json['labBibliography'],
        'subjectEvaluations': !exists(json, 'subjectEvaluations') ? undefined : (json['subjectEvaluations'] === null ? null : (json['subjectEvaluations'] as Array<any>).map(SubjectEvaluationFromJSON)),
        'promotionConditions': !exists(json, 'promotionConditions') ? undefined : json['promotionConditions'],
        'subjectCoroboration': !exists(json, 'subjectCoroboration') ? undefined : json['subjectCoroboration'],
        'studyProgram': !exists(json, 'studyProgram') ? undefined : StudyProgramFromJSON(json['studyProgram']),
        'courseCoordinators': !exists(json, 'courseCoordinators') ? undefined : (json['courseCoordinators'] === null ? null : (json['courseCoordinators'] as Array<any>).map(AcademicUserFromJSON)),
        'labCoordinators': !exists(json, 'labCoordinators') ? undefined : (json['labCoordinators'] === null ? null : (json['labCoordinators'] as Array<any>).map(AcademicUserFromJSON)),
        'laboratories': !exists(json, 'laboratories') ? undefined : (json['laboratories'] === null ? null : (json['laboratories'] as Array<any>).map(LaboratoryFromJSON)),
        'learnings': !exists(json, 'learnings') ? undefined : json['learnings'],
        'learningResultsData': !exists(json, 'learningResultsData') ? undefined : (json['learningResultsData'] === null ? null : (json['learningResultsData'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'fisaLearningOutcomes': !exists(json, 'fisaLearningOutcomes') ? undefined : (json['fisaLearningOutcomes'] === null ? null : (json['fisaLearningOutcomes'] as Array<any>).map(FisaLearningOutcomeDTOFromJSON)),
        'minimumPromotionOutcomes': !exists(json, 'minimumPromotionOutcomes') ? undefined : (json['minimumPromotionOutcomes'] === null ? null : (json['minimumPromotionOutcomes'] as Array<any>).map(FisaLearningOutcomeDTOFromJSON)),
        'eafsgAreas': !exists(json, 'eafsgAreas') ? undefined : json['eafsgAreas'],
        'department': !exists(json, 'department') ? undefined : DepartmentFromJSON(json['department']),
        'disciplineCategory': !exists(json, 'disciplineCategory') ? undefined : DisciplineCategoryEnumFromJSON(json['disciplineCategory']),
        'practiceTotalHours': !exists(json, 'practiceTotalHours') ? undefined : json['practiceTotalHours'],
    };
}

export function SubjectFileDTOToJSON(value?: SubjectFileDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'departmentId': value.departmentId,
        'planDepartmentId': value.planDepartmentId,
        'orderNumber': value.orderNumber,
        'nameRO': value.nameRO,
        'nameEN': value.nameEN,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'studyYear': StudyYearEnumToJSON(value.studyYear),
        'schoolYear': value.schoolYear,
        'planYear': value.planYear,
        'studyProgramId': value.studyProgramId,
        'evaluationType': EvaluationTypeEnumToJSON(value.evaluationType),
        'subjectType': IndicatorTypeEnumToJSON(value.subjectType),
        'subjectCategory': IndicatorTypeEnumToJSON(value.subjectCategory),
        'code': value.code,
        'gradingType': GradingTypeEnumToJSON(value.gradingType),
        'planStatus': StudyPlanStatusEnumToJSON(value.planStatus),
        'status': SubjectStatusEnumToJSON(value.status),
        'isPartiallySaved': value.isPartiallySaved,
        'totalWeeklyHours': value.totalWeeklyHours,
        'courseWeeklyHours': value.courseWeeklyHours,
        'labWeeklyHours': value.labWeeklyHours,
        'seminarWeeklyHours': value.seminarWeeklyHours,
        'projectWeeklyHours': value.projectWeeklyHours,
        'totalHours': value.totalHours,
        'courseHours': value.courseHours,
        'labHours': value.labHours,
        'selfStudyHours': value.selfStudyHours,
        'tutoringHours': value.tutoringHours,
        'examHours': value.examHours,
        'otherActivitiesHours': value.otherActivitiesHours,
        'totalSelfStudyHours': value.totalSelfStudyHours,
        'totalSemesterHours': value.totalSemesterHours,
        'credits': value.credits,
        'creditsIIS': value.creditsIIS,
        'creditsOE': value.creditsOE,
        'labAtPartner': value.labAtPartner,
        'seminarAtPartner': value.seminarAtPartner,
        'projectAtPartner': value.projectAtPartner,
        'practiceAtPartner': value.practiceAtPartner,
        'curriculumPrecondition': value.curriculumPrecondition,
        'respultsPrecondition': value.respultsPrecondition,
        'courseConditions': value.courseConditions,
        'labConditions': value.labConditions,
        'generalObjective': value.generalObjective,
        'specificCompetence': value.specificCompetence,
        'generalCompetence': value.generalCompetence,
        'teachingKnowledges': value.teachingKnowledges,
        'teachingAptitudes': value.teachingAptitudes,
        'teachingResponsabilities': value.teachingResponsabilities,
        'teachingMethods': value.teachingMethods,
        'subjectContents': value.subjectContents === undefined ? undefined : (value.subjectContents === null ? null : (value.subjectContents as Array<any>).map(SubjectContentToJSON)),
        'courseBibliography': value.courseBibliography,
        'labBibliography': value.labBibliography,
        'subjectEvaluations': value.subjectEvaluations === undefined ? undefined : (value.subjectEvaluations === null ? null : (value.subjectEvaluations as Array<any>).map(SubjectEvaluationToJSON)),
        'promotionConditions': value.promotionConditions,
        'subjectCoroboration': value.subjectCoroboration,
        'studyProgram': StudyProgramToJSON(value.studyProgram),
        'courseCoordinators': value.courseCoordinators === undefined ? undefined : (value.courseCoordinators === null ? null : (value.courseCoordinators as Array<any>).map(AcademicUserToJSON)),
        'labCoordinators': value.labCoordinators === undefined ? undefined : (value.labCoordinators === null ? null : (value.labCoordinators as Array<any>).map(AcademicUserToJSON)),
        'laboratories': value.laboratories === undefined ? undefined : (value.laboratories === null ? null : (value.laboratories as Array<any>).map(LaboratoryToJSON)),
        'learnings': value.learnings,
        'learningResultsData': value.learningResultsData === undefined ? undefined : (value.learningResultsData === null ? null : (value.learningResultsData as Array<any>).map(LearningCompetenceDTOToJSON)),
        'fisaLearningOutcomes': value.fisaLearningOutcomes === undefined ? undefined : (value.fisaLearningOutcomes === null ? null : (value.fisaLearningOutcomes as Array<any>).map(FisaLearningOutcomeDTOToJSON)),
        'minimumPromotionOutcomes': value.minimumPromotionOutcomes === undefined ? undefined : (value.minimumPromotionOutcomes === null ? null : (value.minimumPromotionOutcomes as Array<any>).map(FisaLearningOutcomeDTOToJSON)),
        'eafsgAreas': value.eafsgAreas,
        'department': DepartmentToJSON(value.department),
        'disciplineCategory': DisciplineCategoryEnumToJSON(value.disciplineCategory),
        'practiceTotalHours': value.practiceTotalHours,
    };
}

